import React from 'react';

const NotificationTypeFormModal = React.lazy(() => import('../components/FormModal'));
const notificationTypeModalRegistry = {
    notification_notificationTypeId: NotificationTypeFormModal
};
export default notificationTypeModalRegistry;
